/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { Link } from 'react-router';
import styles from './styles.scss';

class SortBtn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ascSort: props.ascSort,
      highLight: props.highLight,
    };
    this.handleClick = this.handleClick.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    const { highLight } = nextProps;
    if (highLight !== this.props.highLight) {
      this.setState({ highLight });
    }
  }
  handleClick() {
    const { ascSort } = this.state;
    const { handleSort, sortName } = this.props;
    this.setState({ ascSort: !ascSort });
    const sort = !ascSort ? sortName : `-${sortName}`;
    handleSort(sort);
  }
  render() {
    const { ascSort, highLight } = this.state;
    const sort = ascSort ? 'asc' : 'desc';
    const iconColor = highLight ? '' : styles.defalutColor;
    return (
      <Link
        className={`pull-right ${iconColor}`}
        onClick={this.handleClick}
      >
        <i className={`fa fa-sort-alpha-${sort}`} aria-hidden="true" />
      </Link>
    );
  }
}

SortBtn.propTypes = {
  sortName: React.PropTypes.string.isRequired,
  ascSort: React.PropTypes.bool,
  handleSort: React.PropTypes.func.isRequired,
  highLight: React.PropTypes.bool.isRequired,
};

SortBtn.defaultProps = {
  ascSort: true,
};

export default SortBtn;




// WEBPACK FOOTER //
// ./src/components/SortBtn/index.jsx